(function () {
  angular.module('MktzapApp.Controllers')
    .controller('WhiteListController', whiteList);

  whiteList.$inject = ['$rootScope', '$window', 'NotificationService', 'WhiteListService', 'WaentService'];

  function whiteList ($rootScope, $window, NotificationService, WhiteListService, WaentService) {
    var vm = this;
    vm.page = 'create';
    vm.whiteList = {};
    vm.loadChannelsOptions = loadChannelsOptions
    vm.resetChannels = resetChannels
    vm.channelDisabled = false

    loadWhiteLists();

    function loadWhiteLists () {
      if (vm.page == 'create') {
        vm.whiteList = {};
        WhiteListService
          .all()
          .$promise
          .then(function (data) {
            vm.whiteListData = data;
          })
          .catch(function () {
            NotificationService.errorHandler(error, $rootScope.labels.errorLoadWhiteLists);
          });
      } else if (vm.page == 'contacts' && vm.whiteListId) {
        vm.edit(vm.whiteListId);
      }
    }

    vm.hasContactsWithSubAccountId = function () {
      let contacts = vm.whiteList.contacts
      if (!contacts) {
        return false
      }

      return contacts.some(function (contact) {
        return contact.subAccountId
      })
    }

    function resetChannels () {
      vm.whiteList.channels_id = null
      loadChannelsOptions()
    }

    function loadChannelsOptions () {
      WhiteListService
        .loadChannels({
          channelable_type: vm.whiteList.channelable_type
        })
        .$promise
        .then(function (data) {
          vm.channels_list = data
        })
        .catch(function () {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadChannels)
        })
    }

    vm.formatTagsNames = function (items) {
      const newItems = [];

      items.forEach(function (item) {
        if (item.text) {
          newItems.push(item.text);
          return;
        }

        newItems.push(item);
      });

      return newItems.join(', ');
    }

    vm.save = function () {
      if (vm.whiteList._id === undefined) {
        WhiteListService
          .create(
            {},
            vm.whiteList
          )
          .$promise
          .then(function (data) {
            if (data.success) {
              loadWhiteLists()
              NotificationService.successHandler(data, $rootScope.labels.savedWithSuccess)
            } else {
              NotificationService.errorHandler(data, data.errorMsg)
            }
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorSavingWhiteList)
          })
      } else {
        WhiteListService
          .update(
            {
              id: vm.whiteList._id,
              index: vm.whiteListContactIndex,
              page: vm.page
            },
            vm.whiteList
          )
          .$promise
          .then(function (data) {
            if (data.success) {
              loadWhiteLists()
              vm.whiteListContactIndex = null
              NotificationService.successHandler(data, $rootScope.labels.savedWithSuccess)
            } else {
              NotificationService.errorHandler(data, data.errorMsg)
            }
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorSavingWhiteList)
          })
      }
    }

    vm.edit = function (whiteListId) {
      WhiteListService
        .findOne({
          id: whiteListId
        })
        .$promise
        .then(function (data) {
          vm.whiteList = data
          if (vm.whiteList.isWaent) {
            vm.whiteList.showSubAccounts = true
            vm.whiteList.channel = vm.whiteList.channels_id[0]
            vm.whiteList.channels_id = vm.whiteList.channels_id[0].id
            WaentService.getSubChannels({
              channels: [vm.whiteList.channel]

            })
              .$promise
              .then(function (data) {
                if (data[0]) {
                  vm.whiteList.subAccounts = data[0].subChannels
                }
              })
            vm.channelDisabled = false
            const hasContactsWithSubAccount = vm.hasContactsWithSubAccountId()
            if (vm.page === 'create' && hasContactsWithSubAccount) {
              NotificationService.warningHandler(null, $rootScope.labels.contactsWithSubAccountWarning)
              vm.channelDisabled = true
            }
          }
          loadChannelsOptions()
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorSavingWhiteList)
        })
    }

    vm.delete = function (whiteListId, index) {
      var confirmation = $window.confirm($rootScope.labels.confirmDeleteWhiteList);
      if (confirmation) {
        vm.whiteListData.splice(index, 1);

        WhiteListService
          .delete({
            id: whiteListId
          })
          .$promise
          .then(function (data) {
            if (data && data.success) {
              NotificationService.successHandler(data, $rootScope.labels.successSaveWhiteList);
            } else {
              NotificationService.errorHandler(data, $rootScope.labels.errorDeletingWhiteListe);
            }
            loadWhiteLists();
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorDeletingWhiteList);
          });
      }
    }

    vm.goToContactsPage = function (whiteListId) {
      vm.page = 'contacts';
      vm.whiteList.contact = {};
      WhiteListService
        .findOne({
          id: whiteListId
        })
        .$promise
        .then(function (data) {
          vm.whiteList = data;
          vm.whiteListId = whiteListId;
          if (vm.whiteList.isWaent) {
            vm.whiteList.channel = vm.whiteList.channels_id[0];
            vm.whiteList.showSubAccounts = true;
            WaentService.getSubChannels(
              {
                channels: [vm.whiteList.channel]
              }
            )
              .$promise
              .then(function (data) {
                if (data[0]) {
                  vm.whiteList.subAccounts = data[0].subChannels;
                }
              });
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });
    }

    vm.editContact = function (index) {
      vm.whiteList.contact = angular.copy(vm.whiteList.contacts[index]);
      vm.whiteListContactIndex = index;
    }

    vm.deleteContact = function (index) {
      var confirmation = $window.confirm($rootScope.labels.confirmDeleteContact);
      if (confirmation) {
        WhiteListService
          .deleteContact(
            {
              whiteList: vm.whiteList,
              index: index
            }
          )
          .$promise
          .then(function (data) {
            loadWhiteLists();
            NotificationService.successHandler(data, $rootScope.labels.updatedWithSuccess);
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorDeletingContact);
          });
      }
    }

    vm.goToCreatePage = function () {
      vm.page = 'create';
      vm.whiteList = {};
    }

    vm.getSubaccountName = function (subAccountId) {
      var subAccountName = ''
      if (vm.whiteList.subAccounts) {
        var subAccount = vm.whiteList.subAccounts.find(subAccount => subAccount.accountId === subAccountId)
        if (subAccount) {
          subAccountName = subAccount.name
        }
      }
      return subAccountName
    }
  }
})();
